/**
 * @deprecated これらの関数は @monorepo/common から直接インポートしてください
 * 例: import { newDate, isPeriod, diffDateTimeHours } from '@monorepo/common'
 */
export { newDate, isPeriod, diffDateTimeHours } from '@monorepo/common';
